import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    // Anchor links (e.g. the app's /privacy#session-replay): scroll to the
    // section once the page has rendered
    const id = decodeURIComponent(hash.slice(1));
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView();
    }, 0);
    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}

